@let langSignalValue = languageService.langSignal();
<mat-drawer-container autosize>
  <!-- Settings -->
  <mat-drawer #drawer class="settings-sidenav" mode="over" position="end">
    <button mat-icon-button class="close-button" (click)="drawer.toggle()">
      <fa-icon [icon]="['far', 'times']"></fa-icon>
    </button>
    <ng-container *ngTemplateOutlet="marwisSettings"></ng-container>
  </mat-drawer>

  <div class="base-container">
    @let featureValue = feature();
    @let marwisIdValue = marwisId();
    @let vecicleNamesValue = vecicleNames();
    @let selectedParameterValue = selectedParameter();
    <a id="start"></a>

    <form class="marwis-native-form">
      <!-- FILTER PANEL (Echtes Glass-Design auf einer horizontalen Linie) -->
      <div class="panel marwis-filter-panel">
        <!-- Sektion: Fahrzeug-Auswahl (Car Select) -->
        @let marwisCarsValue = marwisCars();
        @if (marwisCarsValue.length > 1) {
          <mat-form-field
            appearance="fill"
            class="archive-inline-select marwis-select-field">
            <mat-label>{{
              'PRODUCT.MARWIS.FORM.SELECTMARWIS' | translate
            }}</mat-label>
            <mat-select
              [formControl]="carControl"
              placeholder="{{
                'PRODUCT.MARWIS.FORM.SELECTMARWIS' | translate
              }}">
              @for (car of marwisCarsValue; track $index) {
                <mat-option
                  [value]="car.id"
                  (onSelectionChange)="onStationChange($event)">
                  {{ car.id }} - {{ car.name }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        } @else if (marwisIdValue) {
          <!-- Fest vorgegebenes Einzelfahrzeug als edles Glass-Badge -->
          <div class="marwis-static-vehicle-badge">
            <fa-icon
              [icon]="['far', 'truck-container']"
              class="vehicle-icon"></fa-icon>
            <span class="vehicle-text"
              >{{ marwisIdValue }} -
              {{ vecicleNamesValue[marwisIdValue] }}</span
            >
          </div>
        }

        <!-- Sektion: Zeitraum-Auswahl (Timerange Select) -->
        @let tourMonthsValue = tourMonths();
        @if (tourMonthsValue.length > 0) {
          <mat-form-field
            appearance="fill"
            class="archive-inline-select marwis-select-field">
            <mat-label>{{
              'PRODUCT.MARWIS.FORM.SELECTTIMERANGE' | translate
            }}</mat-label>
            <mat-select
              [formControl]="timerangeControl"
              placeholder="{{
                'PRODUCT.MARWIS.FORM.SELECTTIMERANGE' | translate
              }}">
              @for (month of tourMonthsValue; track $index) {
                <mat-option
                  [value]="month"
                  (onSelectionChange)="onMonthChange($event)">
                  {{
                    month === 'LATEST'
                      ? ('PRODUCT.MARWIS.FORM.LATESTTOUR' | translate)
                      : month
                  }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        }

        <!-- Sektion: Touren-Auswahl (Tour Select) -->
        @let tourDatesValue = tourDates();
        @if (tourDatesValue.length > 0) {
          <mat-form-field
            appearance="fill"
            class="archive-inline-select marwis-tour-select-field">
            <mat-label>{{
              'PRODUCT.MARWIS.FORM.SELECTTOUR' | translate
            }}</mat-label>
            <mat-select
              [formControl]="tourControl"
              placeholder="{{ 'PRODUCT.MARWIS.FORM.SELECTTOUR' | translate }}">
              @for (tour of tourDatesValue; track $index; let i = $index) {
                <mat-option
                  [value]="i"
                  (onSelectionChange)="onTourChange($event)">
                  {{
                    tour.startDtg
                      | datex: 'DD.MM. HH:mm' : undefined : langSignalValue
                  }}
                  -
                  {{
                    tour.endDtg | datex: 'HH:mm' : undefined : langSignalValue
                  }}
                </mat-option>
              }
            </mat-select>
          </mat-form-field>
        } @else {
          <!-- Barrierefreie Info-Box bei fehlenden Tour-Daten -->
          <div class="marwis-no-data-fallback-box">
            <fa-icon
              [icon]="['far', 'info-circle']"
              class="fallback-info-icon"></fa-icon>
            <span class="fallback-text"
              >Für diesen Zeitraum liegen keine Daten vor.</span
            >
          </div>
        }
      </div>
    </form>

    <div class="marwis-dashboard-grid-row">
      @let geoJsonValue = geoJson();
      @let parametersValue = parameters();

      <div class="grid-zone-map">
        <mat-card appearance="outlined" class="route-grid-card-item">
          <!-- Toolbar Header: Parameter Pills, Titel & Zeitstempel -->
          <div class="route-map-toolbar-header marwis-toolbar-header">
            <!-- Parameter Pill-Box -->
            <div class="route-map-parameter-pill-box">
              @for (parameter of parametersValue; track $index) {
                <button
                  mat-icon-button
                  [ngClass]="
                    parameter === selectedParameterValue
                      ? 'param-toggle-btn is-active'
                      : 'param-toggle-btn'
                  "
                  (click)="onParameterSelect(parameter)"
                  [matTooltip]="
                    'PRODUCT.MARWIS.PARAMETER.' + parameter | translate
                  ">
                  <ng-container
                    appWmIcon
                    [inputParameter]="parameter"
                    [additionalClasses]="['ew-icon-size']"></ng-container>
                </button>
              }
            </div>

            <!-- Parameter Titel Text -->
            <div class="route-map-selected-parameter-title marwis-param-title">
              {{
                'PRODUCT.MARWIS.PARAMETER.' + selectedParameterValue | translate
              }}
            </div>

            <!-- Aktuelles Mess-Datum rechts im Header -->
            @if (featureValue) {
              <div class="route-header-update-badge marwis-date-header-badge">
                <fa-icon
                  [icon]="['far', 'clock']"
                  class="update-icon"></fa-icon>
                <span>
                  {{
                    featureValue.properties.dtg
                      | datex
                        : 'DD.MM.YYYY HH:mm:ss'
                        : undefined
                        : langSignalValue
                  }}
                </span>
              </div>
            }
          </div>

          <mat-divider class="route-divider"></mat-divider>

          <!-- Animation Slider Sektion -->
          @if (
            geoJsonValue &&
            geoJsonValue.hasOwnProperty('features') &&
            geoJsonValue.features.length > 0
          ) {
            <div class="route-slider-bar-zone marwis-slider-zone">
              <div class="action-controls-wrapper marwis-animation-controls">
                <!-- Play/Pause Controls -->
                <div class="controls-play-pause-btn">
                  @if (!animationIsRunning()) {
                    <button
                      mat-icon-button
                      class="control btn-app-play"
                      (click)="onPlay()">
                      <fa-icon [icon]="['far', 'play']"></fa-icon>
                    </button>
                  } @else {
                    <button
                      mat-icon-button
                      class="control btn-app-pause"
                      (click)="onPause()">
                      <fa-icon [icon]="['far', 'pause']"></fa-icon>
                    </button>
                  }
                </div>

                <!-- Der Slider selbst -->
                <div class="route-ngx-slider-container marwis-slider-track">
                  @let sliderOptionsValue = sliderOptions();
                  @if (sliderOptionsValue) {
                    <ngx-slider
                      [(value)]="sliderDate"
                      [options]="sliderOptionsValue"
                      (userChange)="onSliderChange($event)"></ngx-slider>
                  }
                </div>
              </div>
            </div>
            <mat-divider class="route-divider"></mat-divider>
          }

          <!-- Mapbox Frame (Zentraler Höhenhebel) -->
          <div
            class="route-map-card__ratioWrapperMap glass-map-frame marwis-map-viewport">
            <app-map
              [dtgIndex]="carPosition"
              [loadingData]="loading"
              [mapType]="mapType.MARWIS"
              [dtgs]="dtgs"
              [geoJson]="geoJsonValue"
              [parameter]="selectedParameterValue"
              [marwisFeature]="featureValue"
              (marwisClick)="onMapClick($event)"></app-map>
          </div>
        </mat-card>
      </div>
      <div class="grid-zone-infobox">
        <mat-card appearance="outlined" class="route-grid-card-item">
          <!-- Fahrzeug Header-Zone -->
          <mat-card-header class="route-card-header-zone">
            <div class="route-header-title-flex">
              <fa-icon
                mat-card-avatar
                [icon]="['far', 'car']"
                size="lg"
                class="header-avatar-icon icon-accent--epp"></fa-icon>
              <div class="route-title-text-group">
                <mat-card-title class="route-main-title">
                  {{ vecicleNamesValue[marwisIdValue] }}
                </mat-card-title>
                <mat-card-subtitle class="route-sub-title">{{
                  marwisIdValue
                }}</mat-card-subtitle>
              </div>
            </div>
          </mat-card-header>

          <!-- Tabellen- & Legenden-Inhalt -->
          <mat-card-content class="route-card-content-zone marwis-content-zone">
            @if (featureValue) {
              <div class="marwis-table-wrapper">
                <table class="marwis-native-flat-table">
                  <thead>
                    <tr class="marwis-time-header-row">
                      <th colspan="2">
                        <fa-icon [icon]="['far', 'calendar-alt']"></fa-icon>
                        &nbsp;
                        {{
                          featureValue.properties.dtg
                            | datex
                              : 'dd DD.MM.YYYY'
                              : undefined
                              : langSignalValue
                        }}
                      </th>
                      <th class="text-right text-clock-highlight">
                        {{
                          featureValue.properties.dtg
                            | datex: 'HH:mm:ss' : undefined : langSignalValue
                        }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <!-- Geschwindigkeit (Feste Reihe oben) -->
                    <tr class="marwis-data-row">
                      <td class="cell-icon">
                        <fa-icon [icon]="['far', 'tachometer-fast']"></fa-icon>
                      </td>
                      <th class="cell-label">
                        {{ 'PRODUCT.MARWIS.PARAMETER.speed' | translate }}
                      </th>
                      <td class="cell-value">
                        <strong>{{ featureValue.properties.speed }}</strong>
                        <small>km/h</small>
                      </td>
                    </tr>

                    <!-- Schleife durch die dynamischen MARWIS-Messparameter -->
                    @for (parameter of parametersValue; track $index) {
                      <tr
                        class="marwis-data-row"
                        [class.is-selected-parameter]="
                          parameter === selectedParameterValue
                        ">
                        <td class="cell-icon">
                          <span appWmIcon [inputParameter]="parameter"></span>
                        </td>
                        <th class="cell-label">
                          {{
                            'PRODUCT.MARWIS.PARAMETER.' + parameter | translate
                          }}
                        </th>
                        <td
                          class="cell-value cell-dynamic-status-glow"
                          [ngStyle]="{
                            backgroundColor:
                              parameter
                              | getColor: featureValue.properties[parameter],
                            color:
                              parameter
                              | contrastColor
                                : featureValue.properties[parameter],
                          }">
                          @if (
                            parameter.indexOf('tt') > -1 || parameter === 'td'
                          ) {
                            <span class="value-text-bold">
                              {{
                                featureValue.properties[parameter]
                                  | number: '1.1-1'
                              }}
                              <small>{{
                                'PRODUCT.MARWIS.UNIT.' + parameter | translate
                              }}</small>
                            </span>
                          }
                          @if (
                            parameter.indexOf('rh') > -1 ||
                            parameter === 'speed' ||
                            parameter === 'wft'
                          ) {
                            <span class="value-text-bold">
                              {{ featureValue.properties[parameter] }}
                              <small>{{
                                'PRODUCT.MARWIS.UNIT.' + parameter | translate
                              }}</small>
                            </span>
                          }
                          @if (parameter === 'road_condition') {
                            <span class="value-text-condition">
                              {{
                                'PRODUCT.MARWIS.CONDITION.' +
                                  featureValue.properties[parameter] | translate
                              }}
                            </span>
                          }
                        </td>
                      </tr>
                    }
                  </tbody>
                </table>
              </div>
            } @else {
              <!-- Kompakter Lade-Indikator, falls noch kein Feature gefangen wurde -->
              <div class="marwis-loading-placeholder-text">
                <fa-icon
                  [icon]="['far', 'spinner-third']"
                  [animation]="'spin'"></fa-icon>
                &nbsp; Empfange Telemetrie-Daten...
              </div>
            }

            <mat-divider
              class="route-divider inside-content-divider"></mat-divider>

            <!-- Die dynamische MARWIS-Kartenlegende am Fuß der Infobox -->
            <div class="marwis-legend-section-box">
              <h3 class="marwis-legend-title">
                <fa-icon [icon]="['far', 'palette']"></fa-icon> &nbsp;
                {{ 'PRODUCT.MARWIS.MAP.SHOWLEGEND.TITLE' | translate }}
                <span class="legend-param-highlight">
                  {{
                    'PRODUCT.MARWIS.PARAMETER.' + selectedParameterValue
                      | translate
                  }}
                </span>
              </h3>
              <app-marwis-legend
                [parameter]="selectedParameterValue"></app-marwis-legend>
            </div>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
  </div>

  <!-- SIDENAV SETTINGS -->
  <div class="settings-button-stack">
    <!--settings button-->
    <button
      mat-mini-fab
      class="settings-button"
      (click)="drawer.toggle()"
      tp="{{ 'HOME.SETTINGS' | translate }}"
      variation="popper"
      trigger="mouseenter"
      tpPlacement="left">
      <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon>
    </button>
  </div>
</mat-drawer-container>

<!-- Settings-->
<ng-template #marwisSettings>
  <div class="custom-sidenav-panel">
    <h3 class="sidenav-header-title">
      <fa-icon [icon]="['far', 'cogs']" size="lg"></fa-icon> &nbsp;
      {{ 'HOME.SETTINGS' | translate }}
    </h3>

    <div class="sidenav-layout-container">
      <!-- Speed -->
      <h3>{{ 'PRODUCT.RADAR.SPEED' | translate }}</h3>
      <div class="settings-slider">
        <ngx-slider
          [(value)]="speed"
          [options]="animationSpeedOptions()"
          (userChange)="onSpeedSliderChange($event)"></ngx-slider>
      </div>
      <mat-divider></mat-divider>
      <!-- RESET -->
      <p align="center">
        <button mat-raised-button color="primary" (click)="onResetSettings()">
          {{ 'PRODUCT.RADAR.RESET' | translate }}
        </button>
      </p>
    </div>
  </div>
</ng-template>
